import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { InterfaceElementModel, RoleInterfaceElementModel } from 'Pages/interfaceElement'
import { NavConfigItem } from 'Modules'
import { Id } from 'Types/aliases'

type InterfaceElementState = {
	elements: { data: ResponseCatalog<InterfaceElementModel>; requestParams: RequestParams }
	roleElements: { data: RoleInterfaceElementModel[]; requestParams: RequestParams }
	sidebar: {
		structure: NavConfigItem[]
		openedSectionId: number | null
	}
	editId: Id
	dataItem: { [key: string]: string }
	expandId: Id
	dataExpand: InterfaceElementModel
}

const interfaceElementInitialState: InterfaceElementState = {
	elements: {
		data: new ResponseCatalog<InterfaceElementModel>(),
		requestParams: new RequestParams(),
	},
	roleElements: {
		data: [],
		requestParams: new RequestParams(),
	},
	sidebar: {
		structure: [],
		openedSectionId: null,
	},
	editId: null,
	dataItem: {},
	expandId: null,
	dataExpand: null,
}

export namespace interfaceElementNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetAll = PayloadAction<ResponseCatalog<InterfaceElementModel>>
	export type CreateOne = PayloadAction<InterfaceElementModel>
	export type UpdateOne = PayloadAction<{
		interfaceElement: InterfaceElementModel
		id: Id
	}>
	export type DeleteOne = PayloadAction<Id>
	export type GetAllRole = PayloadAction<RequestParams>
	export type SetAllRole = PayloadAction<RoleInterfaceElementModel[]>
	export type CreateOneRole = PayloadAction<RoleInterfaceElementModel>
	export type UpdateOneRole = PayloadAction<{
		roleInterfaceElement: RoleInterfaceElementModel
		id: Id
	}>
	export type DeleteOneRole = PayloadAction<Id>
	export type GetInterfaceElementAvailable = PayloadAction<null>
	export type SetOpenedSectionId = PayloadAction<number>
	export type SetInterfaceElementAvailable = PayloadAction<NavConfigItem[]>
	export type SendOpenedSectionId = PayloadAction<string>
	export type setEditId = PayloadAction<Id>
	export type setDataItem = PayloadAction<{ [key: string]: string }>
	export type setExpandId = PayloadAction<{
		id: Id
		item: InterfaceElementModel
	}>
}

export const interfaceElementSlice = createSlice({
	name: 'interfaceElement',
	initialState: interfaceElementInitialState,
	reducers: {
		getAll: (state, action: interfaceElementNS.GetAll) => {},
		setAll: (state, action: interfaceElementNS.SetAll) => {
			state.elements.data = action.payload
		},
		setRequestParams: (state, action: interfaceElementNS.SetRequestParams) => {
			state.elements.requestParams = action.payload
		},
		clearAll: (state) => {
			state.elements = {
				data: new ResponseCatalog<InterfaceElementModel>(),
				requestParams: new RequestParams(),
			}
		},
		createOne: (state, action: interfaceElementNS.CreateOne) => {},
		updateOne: (state, action: interfaceElementNS.UpdateOne) => {},
		deleteOne: (state, action: interfaceElementNS.DeleteOne) => {},

		getAllRole: (state, action: interfaceElementNS.GetAllRole) => {},
		setAllRole: (state, action: interfaceElementNS.SetAllRole) => {
			state.roleElements.data = action.payload
		},
		setRoleRequestParams: (state, action: interfaceElementNS.SetRequestParams) => {
			state.roleElements.requestParams = action.payload
		},
		createOneRole: (state, action: interfaceElementNS.CreateOneRole) => {},
		updateOneRole: (state, action: interfaceElementNS.UpdateOneRole) => {},
		deleteOneRole: (state, action: interfaceElementNS.DeleteOneRole) => {},
		getInterfaceElementAvailable: (
			state,
			action: interfaceElementNS.GetInterfaceElementAvailable
		) => {},
		setInterfaceElementAvailable: (
			state,
			action: interfaceElementNS.SetInterfaceElementAvailable
		) => {
			state.sidebar.structure = action.payload
		},
		setOpenedSectionId: (state, action: interfaceElementNS.SetOpenedSectionId) => {
			state.sidebar.openedSectionId = action.payload
		},
		sendOpenedSectionId: (state, action: interfaceElementNS.SendOpenedSectionId) => {},
		setEditId: (state, action: interfaceElementNS.setEditId) => {
			state.editId = action.payload
		},
		setDataItem: (state, action: interfaceElementNS.setDataItem) => {
			state.dataItem = action.payload
		},
		setExpandId: (state, action: interfaceElementNS.setExpandId) => {
			state.expandId = action.payload.id
			state.dataExpand = action.payload.item
		},
	},
})
